import { useMemo } from 'react';

import {
	usePetitionDetailsPageData,
	usePetitionDetailsPageFcm,
	usePetitionDetailsPageUserData,
} from 'src/app/pages/petitionGamma/details/pageContext';
import type { DecisionMaker } from 'src/app/pages/petitionGamma/details/shared/types';

type Result = ModelHookResult<{
	showLegislativeBodies: boolean;
	shouldTrackViewEvent: boolean;
}>;

export function useDecisionMakerSection(): Result {
	const { decisionMakersLegislativeBodiesEnabled: fcEnabled } = usePetitionDetailsPageFcm();

	const {
		data: {
			petition: {
				primaryDecisionMakerConnection: { nodes: allDms },
			},
		},
	} = usePetitionDetailsPageData();

	const {
		data: { isUserEligibleForLegislativeBodies },
	} = usePetitionDetailsPageUserData();
	const { lbsPresent, showLegislativeBodies } = useMemo(() => {
		if (!legislativeBodiesPresent(allDms)) return { lbsPresent: false, showLegislativeBodies: false };

		return {
			lbsPresent: true,
			showLegislativeBodies: isUserEligibleForLegislativeBodies,
		};
	}, [allDms, isUserEligibleForLegislativeBodies]);

	return {
		data: {
			shouldTrackViewEvent: fcEnabled && lbsPresent,
			showLegislativeBodies,
		},
	};
}

const legislativeBodiesPresent = (dms: readonly DecisionMaker[]) => {
	// counts dms that can be grouped.
	// returns true if there's at least one group
	const lbNames = new Set();

	for (const dm of dms) {
		const { title, type } = dm;
		if (type === 'POLITICIAN' && title) {
			const lb = title.split(' - ')[0].trim();
			if (lbNames.has(lb)) return true;
			lbNames.add(lb);
		}
	}
	return false;
};
